import { HistogeneticsEntityType } from '@nkr/enums/index';
import { IExpertSystemOrderSummaryWithComments } from './models';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import ReactHtmlParser from 'react-html-parser';

enum ExpertSystemAction {
    Open = 0,
    ReprintDonorRequisition = 1,
    ReprintRecipientRequisition = 2,
    WithdrawDonor = 3
}

const menuItemList = [
    { action: ExpertSystemAction.Open, title: 'Open Expert Analysis' },
    { action: ExpertSystemAction.ReprintDonorRequisition, title: 'Re-Print Donor Requisition' },
    { action: ExpertSystemAction.ReprintRecipientRequisition, title: 'Re-Print Recipient Requisition' },
    { action: ExpertSystemAction.WithdrawDonor, title: 'Withdraw Donor' },
    { action: -1, title: '' }
];

interface IProps {
    data: IExpertSystemOrderSummaryWithComments,
    onMenuToggle: (show: boolean) => void,
    onOpenExpertAnalysis: (expertSystemId: number) => void,
    onPrintRequisition: (orderId: number, id: number) => void,
    onWithDrawDonor: (orderId: number) => void
}

type TProps = IProps;

const ActionButtonRenderer = (props: TProps) => {
    const handlers = {
        [0]: () => props.onOpenExpertAnalysis(props.data.expertSystemId),
        [1]: () => props.onPrintRequisition(props.data.donorOrderId, HistogeneticsEntityType.Donor),
        [2]: () => props.onPrintRequisition(props.data.recipientOrderId, HistogeneticsEntityType.Recipient),
        [3]: () => props.onWithDrawDonor(props.data.expertSystemId)
    };

    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (action: number) => {
        if (handlers.hasOwnProperty(action)) {
            handlers[action]();
        }
    }

    const getUrl = (action: ExpertSystemAction, id: number) => {
        return null;
    };

    const getMenuItems = () => {
        const data = props;

        let menuItems = [];

        menuItems.push(ExpertSystemAction.Open);

        if (props.data.donorOrderId > 0) {
            menuItems.push(ExpertSystemAction.ReprintDonorRequisition);
        }

        if (props.data.recipientOrderId > 0) {
            menuItems.push(ExpertSystemAction.ReprintRecipientRequisition);
        }

        menuItems.push(-1);
        menuItems.push(ExpertSystemAction.WithdrawDonor);

        return menuItems;
    }

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.expertSystemId) : null;
        let id = item.action >= 0 ? props.data.expertSystemId : 'div-' + props.data.expertSystemId + '-' + Math.random() * 10000;
        let title = item.title;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, url, element: <div>{ReactHtmlParser(title.replace(/ /g, '&nbsp;'))}</div> };
            } else {
                return { id, action: item.action, include: true, selectable: false, url, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, url, element: <a href={url}>{ReactHtmlParser(title.replace(/ /g, '&nbsp;'))}</a> };
        }
    });

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                width={300}
                onToggle={handleMenuToggle}
                onSelect={(id: any, action: number) => handleMenuSelection(action)}
            />
        </div>
    );
}

export default ActionButtonRenderer;